<div class="c-loader">
  <i class="c-loader__icon  fa fa-spinner fa-pulse fa-fw"></i>
  <div class="c-loader__text">
    <p>{{message}}</p>
  </div>
</div>
